import React, { useState, useEffect } from 'react';
import { useUser } from '../../context/UserContext';
import { usersAPI } from '../../services/api';
import '../admin/AdminComponents.css';

const UserForm = ({ user, onClose }) => {
  const { roles, updateUser } = useUser();
  const [formData, setFormData] = useState({
    roleId: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user) {
      setFormData({
        roleId: user.roleId || user.role_id || ''
      });
    } else {
      setFormData({
        roleId: roles.length > 0 ? roles[0].id : ''
      });
    }
  }, [user, roles]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.roleId) {
      newErrors.roleId = 'Role is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const userData = {
      roleId: formData.roleId
    };

    try {
      if (user) {
        await updateUser(user.id, userData);
        onClose();
      } else {
        alert('Cannot create OAuth users manually. Users are created automatically when they log in via GTA World OAuth.');
      }
    } catch (error) {
      alert(error.message || 'Failed to save user');
    }
  };

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3 className="admin-modal-title">
            {user ? 'Edit OAuth User' : 'Add User'}
          </h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">
          <form className="admin-form" onSubmit={handleSubmit}>
            {user && (
              <>
                <div className="admin-form-group">
                  <label className="admin-form-label">Username</label>
                  <input
                    type="text"
                    className="admin-form-input"
                    value={user.username || ''}
                    disabled
                  />
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
                    OAuth username (cannot be changed)
                  </p>
                </div>
                <div className="admin-form-group">
                  <label className="admin-form-label">GTA World User ID</label>
                  <input
                    type="text"
                    className="admin-form-input"
                    value={user.gtaWorldUserId || ''}
                    disabled
                  />
                </div>
              </>
            )}
            <div className="admin-form-group">
              <label className="admin-form-label">Role *</label>
              <select
                name="roleId"
                className={`admin-form-select ${errors.roleId ? 'error' : ''}`}
                value={formData.roleId}
                onChange={handleChange}
                required
              >
                <option value="">Select a role</option>
                {roles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
              {errors.roleId && <span className="admin-error-message">{errors.roleId}</span>}
              <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
                {user ? 'Change the role for this OAuth user' : 'OAuth users are created automatically when they log in. You can only edit existing users.'}
              </p>
            </div>
            <div className="admin-form-actions">
              <button type="button" className="admin-button" onClick={onClose}>
                Cancel
              </button>

              {user && (
                <button type="submit" className="admin-button primary">
                  Update Role
                </button>

              )}
            </div>

          </form>

        </div>

      </div>

    </div>

  );
};

export default UserForm;

